import { useId } from "react";

interface LogoProps {
  variant?: "light" | "dark";
  className?: string;
}

const Logo = ({ variant = "light", className = "" }: LogoProps) => {
  const gradientId = useId();
  const textFill = variant === "light" ? "#FFFFFF" : "#011840";

  return (
    <div className={`flex justify-start ${className}`}>
      <a href="/" aria-label="ROLLER Home" className="inline-flex">
        <svg
          viewBox="0 0 191 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 sm:h-8 w-auto"
          aria-hidden="true"
        >
          <path
            d="M50.0898 17.596C52.0335 17.2109 53.5545 16.3455 54.6488 14.9997C55.8577 13.515 56.4622 11.6729 56.4622 9.47363C56.4622 7.75865 56.1501 6.34537 55.5259 5.23381C54.9017 4.11827 54.0602 3.23299 53.0093 2.57796C51.9584 1.92293 50.7575 1.45845 49.4063 1.18453C48.0552 0.914581 46.6567 0.775635 45.2068 0.775635H34.718V31.1095H40.0908V18.255H44.7051L52.0928 31.1095H58.5718L50.0898 17.596ZM48.6794 13.0068C48.0394 13.2768 47.3362 13.4514 46.5698 13.5189C45.8034 13.5904 45.033 13.6261 44.2666 13.6261H40.0868V5.40054H44.7367C45.4202 5.40054 46.1234 5.44421 46.8464 5.52758C47.5733 5.61491 48.233 5.79356 48.8296 6.06351C49.4261 6.33346 49.9081 6.74236 50.2794 7.28623C50.6468 7.83011 50.8325 8.54468 50.8325 9.42997C50.8325 10.4304 50.635 11.2085 50.236 11.7643C49.837 12.32 49.3194 12.7369 48.6794 13.0068Z"
            fill={textFill}
          />
          <path
            d="M181.381 17.596C183.324 17.2109 184.845 16.3455 185.94 14.9997C187.149 13.515 187.753 11.6729 187.753 9.47363C187.753 7.75865 187.441 6.34537 186.817 5.23381C186.192 4.11827 185.351 3.23299 184.3 2.57796C183.249 1.92293 182.048 1.45845 180.697 1.18453C179.346 0.914581 177.948 0.775635 176.498 0.775635H166.009V31.1095H171.382V18.255H175.996L183.384 31.1095H189.863L181.381 17.596ZM179.974 13.0068C179.334 13.2768 178.631 13.4514 177.865 13.5189C177.098 13.5904 176.328 13.6261 175.561 13.6261H171.382V5.40054H176.032C176.715 5.40054 177.418 5.44421 178.141 5.52758C178.868 5.61491 179.528 5.79356 180.124 6.06351C180.721 6.33346 181.203 6.74236 181.574 7.28623C181.942 7.83011 182.127 8.54468 182.127 9.42997C182.127 10.4304 181.93 11.2085 181.531 11.7643C181.132 12.32 180.61 12.7369 179.974 13.0068Z"
            fill={textFill}
          />
          <path
            d="M59.9584 16.0716C59.9584 13.642 60.3574 11.4387 61.1515 9.44984C61.9456 7.4649 63.0478 5.77374 64.4542 4.37237C65.8607 2.97497 67.5397 1.89517 69.4873 1.13692C71.435 0.378673 73.5723 0.00153572 75.9031 0.00153572C78.2616 -0.0262534 80.4226 0.323095 82.3861 1.04958C84.3456 1.77607 86.0365 2.84397 87.4587 4.24136C88.8809 5.64273 89.9871 7.32596 90.7851 9.29899C91.5792 11.268 91.9782 13.4713 91.9782 15.8969C91.9782 18.2669 91.5792 20.4226 90.7851 22.3678C89.9871 24.3091 88.8809 25.9804 87.4587 27.3818C86.0365 28.7831 84.3456 29.8749 82.3861 30.6609C80.4266 31.4469 78.2656 31.8519 75.9031 31.8836C73.5723 31.8836 71.431 31.5065 69.4873 30.7482C67.5397 29.99 65.8646 28.9221 64.4542 27.5366C63.0478 26.1511 61.9456 24.4877 61.1515 22.5465C60.3535 20.5973 59.9584 18.4416 59.9584 16.0716ZM65.5841 15.7262C65.5841 17.3539 65.833 18.8545 66.3308 20.2241C66.8286 21.5937 67.5318 22.7807 68.4404 23.7811C69.3491 24.7815 70.4355 25.5675 71.7036 26.1392C72.9678 26.7109 74.3821 26.9967 75.9466 26.9967C77.511 26.9967 78.9293 26.7109 80.2093 26.1392C81.4893 25.5675 82.5836 24.7815 83.4923 23.7811C84.4009 22.7807 85.1041 21.5977 85.6019 20.2241C86.0997 18.8545 86.3486 17.3539 86.3486 15.7262C86.3486 14.2137 86.0997 12.8004 85.6019 11.4864C85.1041 10.1724 84.4009 9.02109 83.4923 8.03656C82.5836 7.05204 81.4893 6.28188 80.2093 5.72213C78.9293 5.16634 77.5071 4.88845 75.9466 4.88845C74.3821 4.88845 72.9678 5.16634 71.7036 5.72213C70.4394 6.27791 69.3491 7.05204 68.4404 8.03656C67.5318 9.02109 66.8286 10.1724 66.3308 11.4864C65.833 12.8004 65.5841 14.2137 65.5841 15.7262Z"
            fill={textFill}
          />
          <path
            d="M97.0073 0.775635H102.38V26.2265H115.216V31.1095H97.0073V0.775635V0.775635Z"
            fill={textFill}
          />
          <path
            d="M119.139 0.775635H124.512V26.2265H137.347V31.1095H119.143V0.775635H119.139Z"
            fill={textFill}
          />
          <path
            d="M141.266 0.775635H161.264V5.65858H146.639V13.114H160.498V17.997H146.639V26.2225H162.031V31.1055H141.266V0.775635Z"
            fill={textFill}
          />
          <path
            d="M0 31.038H17.3906L8.69531 15.9009L0 31.038Z"
            fill={`url(#${gradientId})`}
          />
          <path
            d="M17.3906 31.038L26.0859 15.9009L17.3906 0.7677H0L17.3906 31.038Z"
            fill="#FF290C"
          />
          <defs>
            <linearGradient
              id={gradientId}
              x1="26.2716"
              y1="15.8532"
              x2="-0.28066"
              y2="30.9513"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#B21500" />
              <stop offset="1" stopColor="#FF290C" />
            </linearGradient>
          </defs>
        </svg>
      </a>
    </div>
  );
};

export default Logo;
